var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08 1.628l.548-.549 23.297 23.298-.548.548L1.079 1.628z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.377 1.08l.549.548L1.628 24.925l-.548-.548L24.377 1.079z"
  })));
}
export default SvgClose;